// ── Cart Upsell: You May Also Like ─────────────────────────────────────────
(function initCartUpsell() {
  if (window.CartUpsellInitialized) return;
  window.CartUpsellInitialized = true;

  let pendingAddedVariantId = null;
  let recommendedTimer = null;
  let recommendedFetching = false;
  let recommendedQueued = false;

  // Debounce: collapse rapid calls, then run once. If a fetch is already
  // in progress, mark a queued retry instead of stacking concurrent requests.
  function scheduleRecommendedFetch(delay) {
    clearTimeout(recommendedTimer);
    recommendedTimer = setTimeout(
      function () {
        if (recommendedFetching) {
          recommendedQueued = true;
          return;
        }
        recommendedFetching = true;
        recommendedQueued = false;
        fetchAndRenderRecommendedProducts().finally(function () {
          recommendedFetching = false;
          if (recommendedQueued) {
            recommendedQueued = false;
            scheduleRecommendedFetch(50);
          }
        });
      },
      delay === null || delay === undefined ? 150 : delay,
    );
  }

  // ── Event delegation ──────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-upsell__btn');
    if (!btn) return;
    const item = btn.closest('.cart-upsell__item');
    if (!item) return;
    handleUpsellClick(item, btn);
  });

  document.addEventListener('change', function (e) {
    const select = e.target.closest('.cart-upsell__variant-select');
    if (!select) return;
    const item = select.closest('.cart-upsell__item');
    if (!item) return;

    item.dataset.variantId = select.value;
    const selected = select.options[select.selectedIndex];
    if (selected) {
      if (selected.dataset.price) {
        const priceEl = item.querySelector('.cart-upsell__price');
        if (priceEl) priceEl.textContent = selected.dataset.price;
      }
      item.dataset.inventoryQty = selected.dataset.inventoryQty || '';
      item.dataset.inventoryPolicy = selected.dataset.inventoryPolicy || '';
    }
    syncUpsellButtonStates();
  });

  // ── Cart update listener (covers theme-initiated cart changes too) ─────────
  document.addEventListener('cart:updated', function () {
    setTimeout(syncUpsellButtonStates, 100);
    scheduleRecommendedFetch(150);
  });

  // ── Drawer opened ─────────────────────────────────────────────────────────
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (cartDrawerEl.classList.contains('active')) {
            syncUpsellButtonStates();
            scheduleRecommendedFetch(50);
          }
        }
      }
    }).observe(cartDrawerEl, { attributes: true });
  }

  // ── Watch drawer for cart re-renders ─────────────────────────────────────
  // Two layers are needed:
  //   1. #CartDrawer childList — fires when CartDrawer.renderContents() swaps
  //      the whole innerHTML (add-to-cart from PDP/listing). The old drawerInner
  //      is removed entirely, so an observer on it alone never fires.
  //   2. .drawer__inner childList — fires when CartDrawerItems replaces only
  //      the inner HTML (qty changes) or our own refreshCartFromSections does.
  const cartDrawerDiv = document.querySelector('#CartDrawer');
  let drawerInner = cartDrawerDiv && cartDrawerDiv.querySelector('.drawer__inner');

  function handleInnerMutation() {
    if (pendingAddedVariantId !== null) {
      const vid = String(pendingAddedVariantId);
      pendingAddedVariantId = null;
      document.querySelectorAll('.cart-upsell__item').forEach(function (item) {
        if (item.dataset.variantId === vid) {
          const btn = item.querySelector('.cart-upsell__btn');
          if (!btn) return;
          const btnText = btn.querySelector('.cart-upsell__btn-text');
          if (btnText) btnText.textContent = 'Added to Cart';
          btn.dataset.added = 'true';
          btn.classList.remove('loading');
          const spinner = btn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }
    scheduleRecommendedFetch(150);
  }

  const drawerInnerObserver = new MutationObserver(handleInnerMutation);

  function reattachInnerObserver() {
    const newInner = cartDrawerDiv && cartDrawerDiv.querySelector('.drawer__inner');
    if (newInner !== drawerInner) {
      drawerInnerObserver.disconnect();
      drawerInner = newInner;
      if (drawerInner) drawerInnerObserver.observe(drawerInner, { childList: true });
    }
  }

  if (drawerInner) drawerInnerObserver.observe(drawerInner, { childList: true });

  // Observe #CartDrawer direct children: fires when renderContents() replaces
  // the whole drawer HTML (e.g. add from PDP while drawer is already open).
  if (cartDrawerDiv) {
    new MutationObserver(function () {
      reattachInnerObserver();
      scheduleRecommendedFetch(150);
    }).observe(cartDrawerDiv, { childList: true });
  }

  // ── Initial render ────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncUpsellButtonStates();
      scheduleRecommendedFetch(0);
    });
  } else {
    syncUpsellButtonStates();
    scheduleRecommendedFetch(0);
  }

  // ── Sync Add/Added to Cart button states ──────────────────────────────────
  async function syncUpsellButtonStates() {
    const items = document.querySelectorAll('.cart-upsell__item');
    if (!items.length) return;
    try {
      const cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });
      items.forEach(function (item) {
        const btn = item.querySelector('.cart-upsell__btn');
        if (!btn) return;
        const btnText = btn.querySelector('.cart-upsell__btn-text');
        const variantId = Number(item.dataset.variantId);
        const cartItem = cart.items.find(function (i) {
          return i.variant_id === variantId;
        });
        const cartQty = cartItem ? cartItem.quantity : 0;
        const inCart = cartQty > 0;
        const invQty = parseInt(item.dataset.inventoryQty, 10);
        const invPolicy = item.dataset.inventoryPolicy;
        const isAtLimit = invPolicy === 'deny' && !isNaN(invQty) && cartQty >= invQty;

        btn.dataset.cartQty = cartQty;

        if (inCart) {
          if (btnText) btnText.textContent = 'Added to Cart';
          btn.dataset.added = 'true';
        } else {
          if (btnText) btnText.textContent = 'Add to Cart';
          delete btn.dataset.added;
        }
        btn.disabled = isAtLimit;
      });
    } catch {
      /* silent */
    }
  }

  // ── Fetch and render recommended product slots ────────────────────────────
  async function fetchAndRenderRecommendedProducts() {
    const upsellList = document.querySelector('.cart-upsell__list');
    if (!upsellList) return;

    const slots = parseInt(upsellList.dataset.recommendedSlots, 10) || 0;
    if (slots <= 0) return;

    const excludeHandles = new Set(
      (upsellList.dataset.excludeHandles || '')
        .split(',')
        .map(function (h) {
          return h.trim();
        })
        .filter(Boolean),
    );

    try {
      const cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });
      if (!cart.items || cart.items.length === 0) return;

      const currency =
        cart.currency ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        'USD';

      // Unique non-GWP product IDs in cart
      const cartProductIds = [];
      const seenCartIds = new Set();
      cart.items.forEach(function (item) {
        const isGwp =
          item.properties &&
          (item.properties['_gwp'] === true || item.properties['_gwp'] === 'true');
        if (!isGwp && !seenCartIds.has(item.product_id)) {
          seenCartIds.add(item.product_id);
          cartProductIds.push(item.product_id);
        }
      });
      if (cartProductIds.length === 0) return;

      // Fetch recommendations per cart product until slots are filled
      const recommended = [];
      const seenIds = new Set();

      for (var pi = 0; pi < Math.min(cartProductIds.length, 3); pi++) {
        if (recommended.length >= slots) break;
        try {
          const data = await fetch(
            '/recommendations/products.json?product_id=' +
              cartProductIds[pi] +
              '&limit=10&intent=related',
          ).then(function (r) {
            return r.json();
          });

          if (!data.products) continue;
          for (var di = 0; di < data.products.length; di++) {
            if (recommended.length >= slots) break;
            const product = data.products[di];
            if (!excludeHandles.has(product.handle) && !seenIds.has(product.id)) {
              excludeHandles.add(product.handle);
              seenIds.add(product.id);
              recommended.push(product);
            }
          }
        } catch {
          /* try next product */
        }
      }

      // Swap out stale items and inject fresh ones in one pass
      upsellList.querySelectorAll('.cart-upsell__item--recommended').forEach(function (el) {
        el.remove();
      });
      recommended.forEach(function (product) {
        const firstVariant =
          product.variants.find(function (v) {
            return v.available;
          }) || product.variants[0];
        if (!firstVariant) return;
        upsellList.appendChild(buildRecommendedItemHTML(product, firstVariant, currency));
      });

      if (recommended.length > 0) await syncUpsellButtonStates();
    } catch {
      /* silent */
    }
  }

  // ── Build recommended item DOM node ──────────────────────────────────────
  function buildRecommendedItemHTML(product, firstVariant, currency) {
    const div = document.createElement('div');
    div.className = 'cart-upsell__item cart-upsell__item--recommended';
    div.dataset.variantId = firstVariant.id;
    div.dataset.inventoryQty =
      firstVariant.inventory_quantity !== null && firstVariant.inventory_quantity !== undefined
        ? firstVariant.inventory_quantity
        : '';
    div.dataset.inventoryPolicy = firstVariant.inventory_management
      ? firstVariant.inventory_policy || 'deny'
      : 'continue';

    const variants = product.variants || [];
    const imageSrc = product.featured_image
      ? getSizedImageUrl(product.featured_image.src || product.featured_image, '200x200')
      : '';
    const price = formatMoney(firstVariant.price, currency);

    // Mirror Liquid's has_only_default_variant: skip select only for lone "Default Title"
    const isDefaultOnly =
      variants.length === 0 || (variants.length === 1 && variants[0].title === 'Default Title');

    let variantHTML = '';
    if (!isDefaultOnly) {
      const isSingle = variants.length === 1;
      const selectClass =
        'cart-upsell__variant-select cart-upsell__variant-select--' +
        (isSingle ? 'single' : 'multiple');

      const options = variants
        .map(function (v) {
          const vPolicy = v.inventory_management ? v.inventory_policy || 'deny' : 'continue';
          return (
            '<option value="' +
            v.id +
            '"' +
            ' data-price="' +
            escapeAttr(formatMoney(v.price, currency)) +
            '"' +
            ' data-inventory-qty="' +
            (v.inventory_quantity !== null && v.inventory_quantity !== undefined
              ? v.inventory_quantity
              : '') +
            '"' +
            ' data-inventory-policy="' +
            escapeAttr(vPolicy) +
            '"' +
            (v.id === firstVariant.id ? ' selected' : '') +
            (!v.available ? ' disabled' : '') +
            '>' +
            escapeHTML(v.title) +
            '</option>'
          );
        })
        .join('');

      variantHTML =
        '<div class="cart-upsell__variant-wrapper">' +
        '<select class="' +
        selectClass +
        '" aria-label="Select variant for ' +
        escapeAttr(product.title) +
        '">' +
        options +
        '</select></div>';
    }

    div.innerHTML =
      '<a href="' +
      escapeAttr(product.url) +
      '" class="cart-upsell__image" tabindex="-1" aria-hidden="true">' +
      (imageSrc
        ? '<img src="' +
          escapeAttr(imageSrc) +
          '" alt="' +
          escapeAttr(product.title) +
          '" width="100" height="100" loading="lazy">'
        : '') +
      '</a>' +
      '<div class="cart-upsell__details">' +
      '<a href="' +
      escapeAttr(product.url) +
      '" class="cart-upsell__title-link">' +
      '<p class="cart-upsell__title">' +
      escapeHTML(product.title) +
      '</p>' +
      '</a>' +
      variantHTML +
      '<p class="cart-upsell__price">' +
      price +
      '</p>' +
      '</div>' +
      '<button type="button" class="cart-upsell__btn">' +
      '<span class="cart-upsell__btn-text">Add to Cart</span>' +
      '</button>';

    return div;
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  function getSizedImageUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?]+)(\?.*)?$/, function (m, ext, qs) {
      return '_' + size + ext + (qs || '');
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2);
    }
  }

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ── Add to cart / increment quantity ─────────────────────────────────────
  async function handleUpsellClick(item, btn) {
    if (btn.disabled) return;
    const variantId = item.dataset.variantId;
    if (!variantId) return;

    const isAdded = btn.dataset.added === 'true';
    const btnText = btn.querySelector('.cart-upsell__btn-text');
    const spinner = btn.querySelector('.loading__spinner');
    const prevText = btnText ? btnText.textContent : '';
    btn.disabled = true;
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    try {
      let responseData;
      if (isAdded) {
        const currentQty = parseInt(btn.dataset.cartQty || '0', 10) || 1;
        responseData = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: currentQty + 1,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        }).then(function (r) {
          return r.json();
        });
      } else {
        responseData = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        }).then(function (r) {
          return r.json();
        });
      }

      pendingAddedVariantId = variantId;
      refreshCartFromSections(responseData);
      scrollCartToTop();
    } catch (e) {
      console.error('Cart upsell error:', e);
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (btnText) btnText.textContent = prevText;
      if (prevText === 'Add to Cart') {
        delete btn.dataset.added;
      } else {
        btn.dataset.added = 'true';
      }
      btn.disabled = false;
    }
  }

  function refreshCartFromSections(data) {
    const sections = data && data.sections;
    if (!sections) return;

    const parser = new DOMParser();

    if (sections['cart-drawer']) {
      const newInner = parser
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('.drawer__inner');
      const existingInner = document.querySelector('#CartDrawer .drawer__inner');
      if (newInner && existingInner) existingInner.innerHTML = newInner.innerHTML;
    }

    if (sections['cart-icon-bubble']) {
      const section = parser
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (section && bubbleEl) bubbleEl.innerHTML = section.innerHTML;
    }

    // Fire cart:updated — this triggers the listener above which calls scheduleRecommendedFetch.
    // The drawerInner MutationObserver also fires and calls scheduleRecommendedFetch.
    // The debounce ensures only one fetch run results from both triggers.
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function scrollCartToTop() {
    const inner = document.querySelector('.cart-drawer .drawer__inner');
    if (inner) inner.scrollTo({ top: 0, behavior: 'smooth' });
  }
})();
// ── End Cart Upsell ──────────────────────────────────────────────────────────
